export const termsTranslations  = {
  termsOfService: {
    title: "شروط الخدمة",
    description: "يرجى قراءة هذه الشروط بعناية قبل استخدام خدماتنا. باستخدام Quality Nexus، فإنك توافق على هذه الشروط.",
    lastUpdated: "آخر تحديث:",
    sections: {
      acceptance: {
        title: "القبول بالشروط",
        content: "من خلال الوصول إلى خدمات Quality Nexus واستخدامها، فإنك تقبل وتوافق على الالتزام بشروط وأحكام هذه الاتفاقية. إذا كنت لا توافق على الالتزام بما ورد أعلاه، فيرجى عدم استخدام هذه الخدمة."
      },
      services: {
        title: "وصف الخدمات",
        content: "توفر Quality Nexus خدمات اختبار البرمجيات، والوصول إلى منصة المجتمع، وبرامج التدريب، وخدمات الاستشارة. تم تصميم خدماتنا لمساعدة المنظمات على تحسين جودة برامجها وربط محترفي ضمان الجودة.",
        categories: {
          title: "فئات الخدمات",
          items: [
            "خدمات الاختبار الشاملة",
            "برامج التوجيه والتدريب",
            "خدمات الاختبار الجماعي",
            "منصة المجتمع والفعاليات"
          ]
        }
      },
      responsibilities: {
        title: "مسؤوليات المستخدم",
        intro: "باستخدام خدماتنا، فإنك توافق على:",
        items: [
          "تقديم معلومات دقيقة وكاملة عند إنشاء الحسابات",
          "استخدام خدماتنا فقط للأغراض القانونية ووفقًا لهذه الشروط",
          "احترام حقوق الملكية الفكرية واتفاقيات السرية",
          "الحفاظ على أمان بيانات اعتماد حسابك"
        ]
      },
      prohibited: {
        title: "الاستخدامات المحظورة",
        intro: "لا يجوز لك استخدام خدماتنا من أجل:",
        items: [
          "انتهاك أي قوانين أو لوائح سارية",
          "انتهاك حقوق الملكية الفكرية",
          "نقل التعليمات البرمجية الضارة أو تنفيذ هجمات أمنية",
          "إرسال رسائل غير مرغوب فيها أو مضايقة أو إساءة معاملة المستخدمين الآخرين",
          "هندسة عكسية أو محاولة استخراج الكود المصدري"
        ]
      },
      intellectualProperty: {
        title: "الملكية الفكرية",
        content: "منصة Quality Nexus، بما في ذلك تصميمها وميزاتها ومحتواها، محمية بقوانين حقوق النشر والعلامات التجارية وقوانين الملكية الفكرية الأخرى. يتم منحك ترخيصًا محدودًا غير حصري لاستخدام خدماتنا للغرض المقصود منها."
      },
      liability: {
        title: "تحديد المسؤولية",
        content: "لن تكون Quality Nexus مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية، بما في ذلك على سبيل المثال لا الحصر، فقدان الأرباح أو البيانات أو الاستخدام أو السمعة التجارية أو أي خسائر غير ملموسة أخرى ناتجة عن استخدامك لخدماتنا."
      },
      availability: {
        title: "توفر الخدمة",
        content: "نسعى جاهدين للحفاظ على توفر خدمة عالية ولكن لا يمكننا ضمان الوصول دون انقطاع. نحتفظ بالحق في تعديل الخدمات أو تعليقها أو إيقافها مع إشعار معقول."
      },
      changes: {
        title: "تغييرات الشروط",
        content: "نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سنقوم بإخطار المستخدمين بالتغييرات المهمة عبر البريد الإلكتروني أو إشعارات المنصة. يعد الاستمرار في استخدام خدماتنا بمثابة قبول للشروط المحدثة."
      },
      contact: {
        title: "اتصل بنا",
        content: "إذا كان لديك أي أسئلة حول شروط الخدمة هذه، يرجى الاتصال بنا على:",
        details: {
          email: "البريد الإلكتروني: legal@qualitynexus.com",
          address: "العنوان: فريق Quality Nexus القانوني",
          businessAddress: "[عنوان عملك]"
        }
      }
    }
  }
};